import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
var _excluded = ["children", "columnDefs", "context", "domLayout", "eventFilters", "eventTableName", "filtersApplied", "floatingFiltersHeight", "frameworkComponents", "getRowHeight", "hasApplyFilterAction", "hasExternalFilters", "externalFiltersButtonLabel", "externalFiltersButtonIcon", "headerCallToAction", "loadingOverlayComponent", "onApplyFilters", "onColumnResized", "onDragStopped", "onFilterChanged", "onGridReady", "onResetFilters", "onSetPageSize", "onToggleExternalFilters", "onToPage", "paginationAttributes", "suppressColumnVirtualisation", "title", "withCustomPagination", "eventGroupName", "searchEventName", "pagination", "pageSizeOptions", "variant"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.object.keys.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable react/prop-types */
import React, { useRef, useLayoutEffect } from 'react';
import { useEventTracker } from '@applyboard/ui-utils';
import { Grid, Button, Box } from "../..";
import FilterFill from "../../icons/FilterFill";
import { BLUE } from "../../constants/colors/hex";
import { AgGrid } from "../AgGrid";
import { AgGridContent, AgGridWrapperStyled, FilterButtonWrapper } from "./styles";
import { GridPagination } from "../GridPagination";
import { PAGE_SIZE_OPTIONS } from "./consts";
import { MiniMap } from "../MiniMap";
export var AG_GRID_DEFAULT_ROW_HEIGHT = 56;
export var AgGridWrapper = function AgGridWrapper(_ref) {
  var children = _ref.children,
    columnDefs = _ref.columnDefs,
    context = _ref.context,
    _ref$domLayout = _ref.domLayout,
    domLayout = _ref$domLayout === void 0 ? 'autoHeight' : _ref$domLayout,
    _ref$eventFilters = _ref.eventFilters,
    eventFilters = _ref$eventFilters === void 0 ? {} : _ref$eventFilters,
    _ref$eventTableName = _ref.eventTableName,
    eventTableName = _ref$eventTableName === void 0 ? null : _ref$eventTableName,
    _ref$filtersApplied = _ref.filtersApplied,
    filtersApplied = _ref$filtersApplied === void 0 ? true : _ref$filtersApplied,
    floatingFiltersHeight = _ref.floatingFiltersHeight,
    frameworkComponents = _ref.frameworkComponents,
    _ref$getRowHeight = _ref.getRowHeight,
    getRowHeight = _ref$getRowHeight === void 0 ? function () {
      return AG_GRID_DEFAULT_ROW_HEIGHT;
    } : _ref$getRowHeight,
    _ref$hasApplyFilterAc = _ref.hasApplyFilterAction,
    hasApplyFilterAction = _ref$hasApplyFilterAc === void 0 ? true : _ref$hasApplyFilterAc,
    hasExternalFilters = _ref.hasExternalFilters,
    externalFiltersButtonLabel = _ref.externalFiltersButtonLabel,
    externalFiltersButtonIcon = _ref.externalFiltersButtonIcon,
    headerCallToAction = _ref.headerCallToAction,
    loadingOverlayComponent = _ref.loadingOverlayComponent,
    onApplyFilters = _ref.onApplyFilters,
    onColumnResized = _ref.onColumnResized,
    onDragStopped = _ref.onDragStopped,
    _onFilterChanged = _ref.onFilterChanged,
    onGridReady = _ref.onGridReady,
    onResetFilters = _ref.onResetFilters,
    onSetPageSize = _ref.onSetPageSize,
    onToggleExternalFilters = _ref.onToggleExternalFilters,
    onToPage = _ref.onToPage,
    paginationAttributes = _ref.paginationAttributes,
    suppressColumnVirtualisation = _ref.suppressColumnVirtualisation,
    title = _ref.title,
    _ref$withCustomPagina = _ref.withCustomPagination,
    withCustomPagination = _ref$withCustomPagina === void 0 ? false : _ref$withCustomPagina,
    eventGroupName = _ref.eventGroupName,
    searchEventName = _ref.searchEventName,
    _ref$pagination = _ref.pagination,
    pagination = _ref$pagination === void 0 ? false : _ref$pagination,
    _ref$pageSizeOptions = _ref.pageSizeOptions,
    pageSizeOptions = _ref$pageSizeOptions === void 0 ? PAGE_SIZE_OPTIONS : _ref$pageSizeOptions,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var agScrollComponent = useRef(null);
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  useLayoutEffect(function () {
    agScrollComponent.current = document.getElementsByClassName('ag-body-horizontal-scroll-viewport')[0];
  }, []);
  var hidePageNavigationGroup = paginationAttributes !== null && paginationAttributes !== void 0 && paginationAttributes.hidePageNavigationGroup ? paginationAttributes === null || paginationAttributes === void 0 ? void 0 : paginationAttributes.hidePageNavigationGroup : false;
  var hideSkipButtons = paginationAttributes !== null && paginationAttributes !== void 0 && paginationAttributes.hideSkipButtons ? paginationAttributes === null || paginationAttributes === void 0 ? void 0 : paginationAttributes.hideSkipButtons : false;
  var hidePageSizeSelector = paginationAttributes !== null && paginationAttributes !== void 0 && paginationAttributes.hidePageSizeSelector ? paginationAttributes === null || paginationAttributes === void 0 ? void 0 : paginationAttributes.hidePageSizeSelector : false;
  return /*#__PURE__*/React.createElement(AgGridWrapperStyled, {
    variant: variant
  }, /*#__PURE__*/React.createElement(Box, {
    mb: 2,
    mr: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    className: "grid-wrapper-header",
    container: true,
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement("h2", null, title)), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1,
    justifyContent: "flex-end"
  }, filtersApplied && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(FilterButtonWrapper, null, /*#__PURE__*/React.createElement(Button, {
    size: "large",
    variant: "outlined",
    color: "blueHover",
    onClick: function onClick() {
      if (eventTableName) {
        trackEvent({
          event: "".concat(eventTableName, " Table - Clicked Reset Filters"),
          group: "".concat(eventTableName, " Table Actions")
        });
      }
      onResetFilters();
    }
  }, "Reset Filters"))), hasApplyFilterAction && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(FilterButtonWrapper, null, /*#__PURE__*/React.createElement(Button, {
    size: "large",
    variant: "outlined",
    color: "blueHover",
    onClick: function onClick() {
      return onApplyFilters();
    },
    "data-cy": "apply filters button"
  }, "Apply Filters"))), hasExternalFilters && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(FilterButtonWrapper, null, /*#__PURE__*/React.createElement(Button, {
    size: "large",
    variant: "outlined",
    color: "blueHover",
    onClick: function onClick() {
      return onToggleExternalFilters();
    },
    "data-cy": "toggle filters button",
    startIcon: externalFiltersButtonIcon || /*#__PURE__*/React.createElement(FilterFill, {
      fill: BLUE[5]
    })
  }, externalFiltersButtonLabel || 'Filters'))), headerCallToAction && /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, headerCallToAction))))), children, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AgGridContent, {
    variant: variant,
    domLayout: domLayout
  }, /*#__PURE__*/React.createElement(AgGrid, _extends({
    applyColumnDefOrder: true,
    columnDefs: columnDefs,
    context: context,
    defaultColDef: {
      resizable: true,
      wrapText: true
    },
    domLayout: domLayout,
    floatingFiltersHeight: floatingFiltersHeight,
    frameworkComponents: frameworkComponents,
    getRowHeight: getRowHeight,
    loadingOverlayComponent: loadingOverlayComponent,
    onColumnResized: onColumnResized,
    onDragStopped: onDragStopped,
    onFilterChanged: function onFilterChanged(filterChangedEvent) {
      if (!!eventFilters && !!eventTableName) {
        var filterModel = filterChangedEvent.api.getFilterModel();
        var eventData = {
          action: 'Search query'
        };
        for (var _i = 0, _Object$keys = Object.keys(filterModel); _i < _Object$keys.length; _i++) {
          var key = _Object$keys[_i];
          if (eventFilters[key]) {
            eventData[eventFilters[key]] = true;
          }
        }
        if (Object.keys(eventData).length > 0) {
          trackEvent({
            data: eventData,
            event: searchEventName || "".concat(eventTableName, " Table - Performed Search"),
            group: eventGroupName || "".concat(eventTableName, " Table Filters")
          });
        }
      }
      _onFilterChanged(filterChangedEvent);
    },
    onGridReady: onGridReady,
    pagination: pagination,
    paginationAutoPageSize: false,
    suppressColumnVirtualisation: suppressColumnVirtualisation,
    suppressPaginationPanel: true,
    withCustomPagination: withCustomPagination,
    hidePageNavigationGroup: hidePageNavigationGroup,
    hideSkipButtons: hideSkipButtons,
    hidePageSizeSelector: hidePageSizeSelector
  }, props)), !withCustomPagination && /*#__PURE__*/React.createElement(GridPagination, {
    pageSize: paginationAttributes.pageSize,
    rowCount: paginationAttributes.totalCount,
    currentPage: paginationAttributes.pageNumber,
    lastPage: paginationAttributes.totalPages,
    setPageSize: onSetPageSize,
    goToPage: onToPage,
    pageSizeOptions: pageSizeOptions,
    hidePageNavigationGroup: hidePageNavigationGroup,
    hideSkipButtons: hideSkipButtons,
    hidePageSizeSelector: hidePageSizeSelector
  }), /*#__PURE__*/React.createElement(MiniMap, {
    targetRef: agScrollComponent
  }))));
};
AgGridWrapper.defaultProps = {
  loadingOverlayComponent: 'loadingOverlay',
  title: '',
  children: null
};
export default AgGridWrapper;